import { CountryCode } from '@/store/ui';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  name: 'CmgSessionExpiredBar',
})
export default class CmgSessionExpiredBar extends Vue {

  getSessionExpiredText(): string {
    return this.currentCountry() === CountryCode.GB
      ? 'You can still order as a guest, or sign in for faster ordering'
      : 'You can still order as a guest or you can sign to get those rewards.';
  }

  currentCountry(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  onClickClose(): void {
    this.$appStore.state.ui.showSessionExpiredBanner = false;
  }
}
